import * as React from "react";
import { AccountSettings } from "@/src/components/AccountSettings";
import { XCircleIcon } from "@/src/components/icons";

interface SubscriptionModalProps {
  onClose: () => void;
}

export const SubscriptionModal: React.FC<SubscriptionModalProps> = ({
  onClose,
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity"
        onClick={onClose}
      />
      <div className="relative bg-white rounded-xl shadow-xl w-full max-w-4xl p-8 animate-in zoom-in-95 fade-in duration-200 max-h-[90vh] overflow-y-auto">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 transition-colors p-2 hover:bg-gray-100 rounded-full"
        >
          <XCircleIcon className="w-6 h-6" />
        </button>

        <div className="mt-4">
          <AccountSettings hideHeader={true} />
        </div>
      </div>
    </div>
  );
};
